export const IMAGE_NOT_FOUND = 'https://www.salonlfc.com/wp-content/uploads/2018/01/image-not-found-1024x576.png';